import React from 'react'
import { Bar } from './items/Bar'
import { Chair } from './items/Chair'
import { Plant } from './items/Plant'
import { Tree } from './items/Tree'
import { Bush } from './items/Bush'
import { Sofa } from './items/Sofa'
import { Wall } from './items/Wall'
import { Window } from './items/Window'
import { Column } from './items/Column'
import { TextItem } from './items/TextItem'
import { BarChair } from './items/BarChair'
import { DoorLeft } from './items/Doors/DoorLeft'
import { DoorRight } from './items/Doors/DoorRight'
import { DoubleDoors } from './items/Doors/DoubleDoors'
import { Table } from './items/Tables/Table'

export const ItemComponent = ({ element, roomColor }) => {
	switch (element.objectKind) {
		case 'table':
			return (
				<Table
					key={element.id}
					positionLeft={element.positionLeft * -1}
					positionTop={element.positionTop * -1}
					height={element.height}
					width={element.width}
					rotation={element.rotationDeg}
					color={element.componentColor}
					caption={element.caption}
					shape={element.shape}
				/>
			)
		case 'chair':
			return (
				<Chair
					key={element.id}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
					rotation={element.rotationDeg}
				/>
			)
		case 'plant':
			return (
				<Plant
					key={element.id}
					position={[
						(element.positionLeft) * -1,
						40,
						(element.positionTop) * -1
					]}
					scale={element.width / 30}
				/>
			)
		case 'tree':
			return (
				<Tree
					key={element.id}
					position={[
						(element.positionLeft) * -1,
						0,
						(element.positionTop) * -1
					]}
					scale={element.width / 30}
				/>
			)
		case 'bush':
			return (
				<Bush
					key={element.id}
					position={[
						(element.positionLeft) * -1,
						0,
						(element.positionTop) * -1
					]}
					scale={element.width / 30}
				/>
			)
		case 'column':
			return (
				<Column
					key={element.id}
					position={[
						(element.positionLeft) * -1,
						50 * element.width / 25,
						(element.positionTop) * -1
					]}
					scale={element.width / 25}
				/>
			)
		case 'doubleDoors':
			return (
				<DoubleDoors
					key={element.id}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop * -1) - 5
					]}
					color={roomColor}
					scale={element.width / 70}
					rotation={element.rotationDeg}
				/>
			)
		case 'doorLeft':
			return (
				<DoorLeft
					key={element.id}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
					color={roomColor}
					scale={element.width / 35}
					height={element.height}
					rotation={element.rotationDeg}
				/>
			)
		case 'doorRight':
			return (
				<DoorRight
					key={element.id}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
					color={roomColor}
					scale={element.width / 35}
					height={element.height}
					rotation={element.rotationDeg}
				/>
			)
		case 'sofa':
			return (
				<Sofa
					key={element.id}
					height={element.height}
					width={element.width}
					rotation={element.rotationDeg}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
				/>
			)
		case 'wall':
			return (
				<Wall
					key={element.id}
					height={element.height}
					width={element.width}
					color={roomColor}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
				/>
			)
		case 'window':
			return (
				<Window
					key={element.id}
					height={element.height}
					width={element.width}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
				/>
			)
		case 'barChair':
			return (
				<BarChair
					key={element.id}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
				/>
			)
		case 'wc':
			return (
				<TextItem
					key={element.id}
					width={element.width}
					// height={element.height}
					rotation={element.rotationDeg}
					text='WC'
					position={[
						element.positionLeft * -1,
						0,
						(element.positionTop + element.height) * -1
					]}
				/>
			)
		case 'exit':
			return (
				<TextItem
					key={element.id}
					width={element.width}
					// height={element.height}
					rotation={element.rotationDeg}
					text='EXIT'
					position={[
						element.positionLeft * -1,
						0,
						element.positionTop * -1
					]}
				/>
			)
		case 'bar':
			return (
				<Bar
					key={element.id}
					width={element.width}
					height={element.height}
					rotation={element.rotationDeg}
					position={[
						(element.positionLeft + element.width / 2) * -1,
						0,
						(element.positionTop + element.height / 2) * -1
					]}
				/>
			)
		default:
			return <></>
	}
}
